import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Tab, Tabs } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import {
    ProductListingResultGrid,
    ProductListingResultGridProps,
} from '../Grid/ProductListingResultGrid'
import { TabContent } from './TabContent'

interface DialogTabsProps {
    listingProps: ProductListingResultGridProps
    rListingProps: Partial<ProductListingResultGridProps>
    setDialogTab: (value: number) => void
    relatedProductsCount?: number
    productsCount?: number
    isRelatedProductsActive?: boolean
}

const useStyles = makeStyles((theme) => ({
    tab: {
        paddingLeft: theme.spacing(3),
    },
    tabLabel: {
        color: '#304959',
        fontSize: pxToRem(16),
        opacity: 0.8,
    },
    tabIndicator: {
        backgroundColor: '#304959',
    },
}))

export const DialogTabs: React.FC<DialogTabsProps> = ({
    listingProps,
    rListingProps,
    setDialogTab,
    relatedProductsCount,
    productsCount,
    isRelatedProductsActive = false,
}) => {
    const classes = useStyles()
    const [selectedTab, setSelectedTab] = React.useState(0)

    const handleTabChange = React.useCallback(
        (event: React.ChangeEvent<{}>, newValue: number) => {
            setSelectedTab(newValue)
            setDialogTab(newValue)
        },
        [setDialogTab, setSelectedTab]
    )

    React.useEffect(() => {
        if (isRelatedProductsActive && selectedTab !== 1) {
            setSelectedTab(1)
        }
    }, [isRelatedProductsActive, selectedTab])

    return (
        <>
            <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                className={classes.tab}
                classes={{ indicator: classes.tabIndicator }}
            >
                <Tab
                    label={`Products (${productsCount ?? 0})`}
                    data-testid="productsTab"
                    disableFocusRipple
                    disableRipple
                    classes={{ textColorInherit: classes.tabLabel }}
                    tabIndex={0}
                ></Tab>
                <Tab
                    label={`Related Products (${relatedProductsCount ?? 0})`}
                    data-testid="relatedProductsTab"
                    disableFocusRipple
                    disableRipple
                    classes={{ textColorInherit: classes.tabLabel }}
                    tabIndex={0}
                ></Tab>
            </Tabs>
            <TabContent>
                {selectedTab === 0 ? (
                    <ProductListingResultGrid {...listingProps} />
                ) : (
                    <ProductListingResultGrid
                        {...{ ...listingProps, ...rListingProps }}
                    />
                )}
            </TabContent>
        </>
    )
}
